import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './InvolvedAddressEditor.html?raw';
import lang from 'dojo/_base/lang';
import _StatefulSection from '../../../../moreCore/UI/_StatefulSection/_StatefulSection';
import { PromoterForm } from "../../../_loadingHelpers/VAMv2";
import { VAM2types } from "../../../_loadingHelpers/VAMv2Types";
import HintBox from '../../../../moreCore/UI/EntityBased/HintBox/HintBox';
import _GlobalSelectEntityDialogsMixin from '../../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { SelectEntityDialogTypes } from "../../../../moreCore/_loadingHelpers/SelectEntityDialog";
import { ExpandableSection, ExpandableSectionMarkings } from "../../../../moreCore/UI/Container/ExpandableSectionTypes";

class InvolvedAddressEditor extends compose(_StatefulSection, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;
    private projectId: string;
    private isNew: boolean = false;

    private input_RelationType: MdsLax<InstanceType<typeof HintBox>>;
    private input_Address: MdsLax<InstanceType<typeof HintBox>>;

    private expanderPromoterForm: MdsLax<InstanceType<typeof ExpandableSection>>;
    private expanderPromoterFormContainer: HTMLElement;
    private promoterForm: MdsLax<InstanceType<typeof PromoterForm>>;

    private sectionContactPerson: HTMLDivElement;
    private input_ContactPerson: MdsLax<InstanceType<typeof HintBox>>;

    isValid(): boolean {

        if (this.input_Address.getValue() == null) return false;

        if (this.getAttributeValue("tmp_is_main_promoter")) return this.promoterForm.isValid();

        return true;
    }

    setIsNew(isNew: boolean) {

        this.isNew = isNew;
        this.input_RelationType.setReadonly(!this.isNew);
    }

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        let c_address_1 = this.getAttributeValue("c_address_1");
        let ref_address = this.getAttributeValue("ref_address");
        let c_relation_type = this.getAttributeValue("c_relation_type");
        let ref_relation_type = this.getAttributeValue("ref_relation_type");

        if (c_address_1 && !ref_address) {
            this.input_Address.setValue(c_address_1, true);
        }
        if (c_relation_type && !ref_relation_type) {
            this.input_RelationType.setValue(c_relation_type, true);
        }

        let isReadonly = this.getAttributeValue("tmp_is_readonly");
        if (isReadonly === true) this.setReadonly(isReadonly);

        if (this.getAttributeValue("tmp_is_main_promoter")) {
            this.promoterForm.prepareView();
            this.expanderPromoterForm.setMarking(ExpandableSectionMarkings.hasContent);
            this.hideNode(this.expanderPromoterFormContainer, false);
            this.input_Address.setReadonly(true);
            this.input_RelationType.setReadonly(true);
            this.hideNode(this.sectionContactPerson, false);
        }

        this.input_ContactPerson.addAdditionalRequestParameter("organisation", ref_address);
    } 

    externalEventHandler(event: "ok") {

        switch (event) {
            case "ok":
                if (!this.isValid()) {
                    this._showErrorMessage(this.translate("General_Error_InvalidData"));
                    return;
                }
                this._onClicked_OK();
                break;
            default:
                this._showErrorMessage(`Wrong external event! **${event}** event not supported!`)
        }
    }
    private _onClicked_OK() {

        var jsonData = {
            ID: this.entityId,
            changedData: this.changedData
        }

        if (this.isValid()) {
            this.emit("okClicked", jsonData);
        } else {
            this.showToast(this.translate("General_Error_InvalidData"), "fas fa-exclamation-triangle");
        }
    }
    private _onChangeAddress(val: string | VAM2types.Entity_gDisp) {

        if (typeof val == "string") this.setAttributeValue("c_address_1", val);
        else this.setAttributeValue("c_address_1", val.gDisp_1);
    }

    private _onChangeContactPerson() {
        
    }

    private _onChangeRelationType(val: string | VAM2types.RelationType) {

        if (typeof val == "string") {

            this.setAttributeValue("c_relation_type", val)
            this.setAttributeValue("ref_relation_group.description", null)
        } else {

            this.setAttributeValue("c_relation_type", val.description)
            this.setAttributeValue("ref_relation_group.description", val.ref_relation_group?.description)
        }
    }

    applyAllreadyChangedData(data: VAM2types.InvolvedAddress) {

        if (this.isNew) this.setData(data);
        else {
            for (let p in data) {
                switch (p) {
                    //case "ref_address":
                    //case "ref_relation_type":
                    //    if (typeof data[p] == "string") {

                    //    }
                    //    break;
                    default:
                        this.setAttributeValue(p, data[p]);
                }
                    
                
            }
        }
        if (this.getAttributeValue("tmp_is_main_promoter")) {
            this.promoterForm.prepareView();
        }
    }

    setProjectId(projectId: string) {

        this.projectId = projectId;
    }

    private _onClick_OpenSED(mode, evt) {
        let additionalData = {};

        if (mode === "selectContactPerson") {
            additionalData["organisation"] = this.getAttributeValue("ref_address");
        }

        this.loadSelectEntityDialog(evt,
            mode,
            lang.hitch(this, this._onCallback_Dlg),
            null,
            additionalData
        );
    }
    private _onCallback_Dlg(mode: string, data, items: Array<SelectEntityDialogTypes.Item<any>>) {

        if (!items || !items.length) return;
        let entity = items[0].entry.data;
        switch (mode) {
            case "selectAddress":
                //this.input_Address.setValue(entity);
                this.setAttributeValue("ref_address", entity as VAM2types.Entity_gDisp);
                break;
            case "selectRelationType":
                //this.input_RelationType.setValue(entity);
                this.setAttributeValue("ref_relation_type", entity as VAM2types.RelationType);
                break;
            case "selectContactPerson":
                this.setAttributeValue("ref_contact_person", entity);
                break;
            default:
                this._showErrorMessage(`Wrong SelectEntityDialogMode - '${mode}''`)
        }
    }
    private _showErrorMessage(msg?: string) {
        var errorMessage = msg ? msg : "...error occured";
        this.showToast(errorMessage, "fas fa-exclamation-triangle");
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.SEDconfigCallfunction = "Webtool_API__ProjectWizard__InvolvedAddresses_SED_GetConfig";
        this.input_Address.addInlineButton(lang.hitch(this, this._onClick_OpenSED, "selectAddress"));
        this.input_RelationType.addInlineButton(lang.hitch(this, this._onClick_OpenSED, "selectRelationType"));
        this.input_ContactPerson.addInlineButton(lang.hitch(this, this._onClick_OpenSED, "selectContactPerson"));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(InvolvedAddressEditor);